import { writeStored } from "@/lib/safeStorage";
import {
    useSdk,
    type AgentModelChoice,
} from "@cs_teamwaydev/mailvista-sdk_react";
import { useEffect, useState } from "react";

// The choice once kept in this browser (« small », « medium » before 21/10): overwritten with « auto ».
const AGENT_MODEL_KEY = "mailvista.assistant.model";

/**
 * Step-based contract: the assistant's model choice. Since 21/10, « Auto » only: the agent follows the
 * model the organization picks in the settings (model catalogue), when the Api-Ai serves it, and keeps
 * its own otherwise. The selector under the input box shows the catalogue greyed (ModelSelector).
 */
const useAgentModel = () => {
    const { conversationManager } = useSdk();
    const [agentModel, setAgentModel] = useState<AgentModelChoice>("auto");

    useEffect(() => {
        conversationManager?.setAgentModel?.(agentModel);
        writeStored(AGENT_MODEL_KEY, agentModel);
    }, [conversationManager, agentModel]);

    return { agentModel, setAgentModel };
};

export default useAgentModel;
